module.exports = __webpack_public_path__ + "static/media/3.427b8811.jpg";